module.exports = __webpack_public_path__ + "static/img/service-3.b07f38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/service-3.png
// module id = p1Jz
// module chunks = 1